import { render } from "./candidat_detail.vue?vue&type=template&id=5f183325"
import script from "./candidat_detail.vue?vue&type=script&lang=js"
export * from "./candidat_detail.vue?vue&type=script&lang=js"

import "./candidat_detail.vue?vue&type=style&index=0&id=5f183325&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__